export const LV_CurrencyTR={
CurrID:{en:'CurrID',cs:'CurrID',dataType:'number',format:'#0',required:true},
CurrName:{en:'Currency',cs:'Měna',dataType:'string',required:true,maxLength:255},
CurrExchangeRate:{en:'Exchange Rate',cs:'Kurz',dataType:'number',format:'#0.00',required:true},
CurrTimeStamp:{en:'CurrTimeStamp',cs:'CurrTimeStamp',dataType:'number',format:'#0'}
}